export function getFile(moduleIdent, fileId, isDownload) {
    const url = `api/Storage/GetFile?${moduleIdent ? `&moduleIdent=${moduleIdent}` : ''}&fileGuid=${fileId}${isDownload ? `&isDownload=${isDownload}` : '' }`;
    const link = document.createElement('a');
    link.href = url;
    link.target = '_self';
    link.click();
}